<template>
  <div ref="scrollWrap" class="sl-scroll-wrap" :style="{height:height+'px'}" @DOMMouseScroll.prevent="handlescroll" @mousewheel.prevent="handlescroll">
    <div ref="scrollBody" class="sl-scroll-bd" :style="{left: left + 'px' , top: top + 'px'}">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Scroll',
  props: {
    type:{type:String , default:'h'}
  },
  data() {
    return {
      left : 0 , top:0 , height:0
    }
  },
  computed: {
    
  },
  updated(){
    this.height = this.$refs.scrollBody ? this.$refs.scrollBody.offsetHeight : 0
  },
  mounted(){
    // this.height = this.$refs.scrollBody.offsetHeight
  },
  methods: {
    handlescroll(e) {
      let type = e.type , delta = 0 , dist = 0
      if (type === 'DOMMouseScroll' || type === 'mousewheel') {
        delta = (e.wheelDelta) ? e.wheelDelta : -(e.detail || 0) * 30
      }

      this.update( delta )
      
    },

    update(val = 0 , delta = true){
      let dist

      if( this.type == 'h'){
        dist = delta ? (this.left + val) :  val
        let wrapWidth = this.$refs.scrollWrap.offsetWidth
        let bodyWidth = this.$refs.scrollBody.offsetWidth
        if( dist > 0 || bodyWidth <= wrapWidth){
          dist = 0
        }
        else if(dist < wrapWidth - bodyWidth){
          dist = wrapWidth - bodyWidth
        }
        console.log( dist )
        this.left = dist
      }else if(this.type == 'v'){
        dist = delta ? (this.top + val) : val

        let wrapHeight = this.$refs.scrollWrap.offsetHeight
        let bodyHeight = this.$refs.scrollBody.offsetHeight
        if( dist > 0 || bodyHeight < wrapHeight){
          dist = 0
        }
        else if(dist < wrapHeight - bodyHeight){
          dist = wrapHeight - bodyHeight
        }
        this.top = dist
      }
    },

    scrollTo(index){
      if(!(this.$refs.scrollBody && this.$refs.scrollBody)) return

      let children = this.$refs.scrollBody.childNodes
      if( children.length > index ){
        let el = children[index]
        if( this.type == 'h'){
          let left = el.offsetLeft , height = el.offsetHeight , width = el.offsetWidth
          let wrapWidth = this.$refs.scrollWrap.offsetWidth
          let bodyWidth = this.$refs.scrollBody.offsetWidth
          let view_left = this.left + left

          //重新滚动
          if(
            this.left < 0 || 
            this.left > wrapWidth - bodyWidth ||  
            view_left < 0 || 
            view_left > wrapWidth - width
          ){
             this.update( (wrapWidth - width) / 2 - left  , false)
          }
          
        }

      }
    }
  }
}

</script>
<style lang='scss'>
.sl-scroll-wrap {
  overflow: hidden;
  width: 100%;
  position:relative;
  .sl-scroll-bd {
    position:absolute;
    white-space: nowrap;
    transition: left .3s ease;
  }
}

</style>
